// extracted by mini-css-extract-plugin
export default {"fullscreen-icon":"OhLalamoveMap_fullscreen-icon__CYE1z","lalamove-map":"OhLalamoveMap_lalamove-map__EmMNB","iframe":"OhLalamoveMap_iframe__ll03s"};